var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/notifications/components/setting_toggle.tsx";
import React from 'react';
import { Toggle } from 'soapbox/components/ui';
/** Stateful toggle to change user settings. */
const SettingToggle = ({
  id,
  settings,
  settingPath,
  onChange
}) => {
  const handleChange = ({
    target
  }) => {
    onChange(settingPath, target.checked);
  };
  return /*#__PURE__*/React.createElement(Toggle, {
    id: id,
    checked: !!settings.getIn(settingPath),
    onChange: handleChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 5
    }
  });
};
export default SettingToggle;